let bundleVariantData=[];
let currentStep = 0;
$(document).ready(function () {
    let itemCount = 3;
    function removeItem(button) {
        const $item = $(button).closest('.item-card');
        $item.css({
            transition: 'opacity 0.3s ease, transform 0.3s ease',
            opacity: 0,
            transform: 'scale(0.8)'
        });
        setTimeout(() => $item.remove(), 300);
    }

    
    const $tabItems = $('.step-title');
    const $blockItems = $('.block-item');
    const $progressPercent = $('#progressPercent');
    const totalSteps = $tabItems.length;

    function updateUI() {
        console.log("currentStep",currentStep,bundleVariantData.length);
        if(currentStep>=3 && bundleVariantData.length==0){
            if(jQuery('.multi-step-bundle-builder-section').find('.cart-footer').find('.error-msg').length>0){
                jQuery('.multi-step-bundle-builder-section').find('.cart-footer').find('.error-msg').show();
            }
            return false;
        }else{
            if(jQuery('.multi-step-bundle-builder-section').find('.cart-footer').find('.error-msg').length>0){
                jQuery('.multi-step-bundle-builder-section').find('.cart-footer').find('.error-msg').hide();
            }
        }
        if(bundleVariantData.length>0){
            if(currentStep==3){
                jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').hide();
            }else{
                jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').show();
            }
        }
        $tabItems.each(function (i) {
            $(this).removeClass('active current-active');
            if (i < currentStep) $(this).addClass('active');
            if (i === currentStep) $(this).addClass('current-active active');
        });

        $blockItems.each(function (i) {
            $(this).toggleClass('active', i === currentStep);
        });

        // Update progress
        $progressPercent.css('width', Math.round(((currentStep + 1) / totalSteps) * 100) + '%');

        // Update buttons
        $('#backBtn').prop('disabled', currentStep === 0);
        $('#nextBtn').prop('disabled', currentStep === totalSteps - 1);

        sliderRefresh();
        sameBoxCard();
        if(currentStep==3){
            reserveTimer();
        }else if(currentStep==2){
            accessoriesBoxCard();
        }
    }

    $(document).on('click', '#nextBtn', function () {
        if (currentStep < totalSteps - 1) {
            currentStep++;
            updateUI();
        } else {
            if(jQuery('.multi-step-bundle-builder-section').find('.cart-footer').find('.error-msg').length>0){
                jQuery('.multi-step-bundle-builder-section').find('.cart-footer').find('.error-msg').show();
            }
        }
    });

    $(document).on('click', '#backBtn', function () {
        if (currentStep > 0) {
            currentStep--;
            updateUI();
        }
    });

    $(document).on('click', '.step-title', function () {
        currentStep = $('.step-title').index(this);
        if(bundleVariantData.length==0){
            return false;
        }
        updateUI();
    });

    updateUI();
    sameBoxCard();
    setColorName();
});

function resetTabsAndProgress() {
    var $tabItems = $('.multi-step-bundle-builder-section .step-title');
    var $blockItems = $('.multi-step-bundle-builder-section .block-item');
    var $progressPercent = $('#progressPercent');
    var totalSteps = $tabItems.length;

    // Reset current step to first
    currentStep = 0;

    // Reset tabs
    $tabItems.each(function(i){
        $(this).removeClass('active current-active');
        if(i === 0) $(this).addClass('current-active active');
    });

    // Reset block items
    $blockItems.each(function(i){
        $(this).toggleClass('active', i === 0);
    });

    // Reset progress bar
    $progressPercent.css('width', Math.round((1 / totalSteps) * 100) + '%');

    // Reset buttons
    $('#backBtn').prop('disabled', true);
    $('#nextBtn').prop('disabled', false);

    // Hide sticky cart container
    $('.multi-step-bundle-builder-section .sticky-cart-container').hide();

    sliderRefresh();
    sameBoxCard();
}

function sliderRefresh() {
    var sliderId = setInterval(function(){
        if($('.page-container')
            .find('.multi-step-bundle-builder-section')
            .find('.pro-collection-gallery.slick-initialized').length>0){
            var $gallery = $('.page-container')
                .find('.multi-step-bundle-builder-section')
                .find('.pro-collection-gallery');

            if ($gallery.length > 0) {
                $gallery.slick('refresh');
            }
            clearInterval(sliderId);
        }
    },100);
}
jQuery(document).on("click",".sticky-cart-container .cart-pack-list",function(){
    if($('#cartContainer').length>0){
        $('#cartContainer').toggleClass('collapsed');
    }
});

jQuery(document).ready(function($) {
  var $accordions = $('.bundle-faq--wrapper .faq-accordion');

  // Open first accordion by default
  $accordions.find('.faq-header').on('click', function() {
    var $accordion = $(this).closest('.faq-accordion');

    // Toggle this accordion
    $accordion.toggleClass('active');
    $accordion.find('.faq-body').slideToggle();

    // Toggle open class on header
    $(this).toggleClass('open');

    // Close other accordions
    $accordion.siblings('.faq-accordion').removeClass('active').find('.faq-body').slideUp();
    $accordion.siblings('.faq-accordion').find('.faq-header').removeClass('open');
  });
});

/************************************ PRODUCT COLOR VARAINT ACTIVE CLICK JS START ********************************/

jQuery(document).on("click",".grid-product__colors .color-swatch--with-image",function(){
    if(jQuery(this).parent().find(".color-swatch--with-image").length>0){
        jQuery(this).parent().find(".color-swatch--with-image").removeClass('active');
        jQuery(this).addClass('active');
    }
    var getColor = jQuery(this).attr('data-value');
    if(jQuery(this).parent().parent('div').find('.selected-color').length>0){
        jQuery(this).parent().parent('div').find('.selected-color').text(getColor);
    }
    var $productInfo = jQuery(this).closest('.product-info');
    var selectedVariantId = getVariantId($productInfo);
    var $quantitySelector = $productInfo.find('.quantity-selector');
    var $addButton = $productInfo.find('.product-btn');
    
    // Find variant in the bundle data array
    var variantData = false;
    if(selectedVariantId!="" && selectedVariantId!=undefined){
        variantData = bundleVariantData.find(function(item) {
            return item.variant_id == selectedVariantId;
        });
    }
    var totalqnt = getTotalVariantQuantity(selectedVariantId);
    if(jQuery('.multi-step-bundle-builder-section').find('.quantity-value').length>0){
        //console.log("variantData",variantData);
        if (variantData) {
            // Variant already in bundle → show quantity, hide add button
            $quantitySelector.show();
            $addButton.hide();

            // Set input to stored quantity
            $quantitySelector.find('.quantity-value').val(totalqnt);
            $quantitySelector.find('.quantity-value').attr('data-variant-id',selectedVariantId);
        } else {
            // Variant not in bundle → show add button, hide quantity
            $quantitySelector.hide();
            $addButton.show();

            // Reset input to minimum
            var min = parseInt($quantitySelector.find('.quantity-value').attr('min')) || 1;
            $quantitySelector.find('.quantity-value').val(min);
            $quantitySelector.find('.quantity-value').attr('data-variant-id',selectedVariantId);
        }
    }
});

/************************************* PRODUCT COLOR VARAINT ACTIVE CLICK JS END *********************************/

/************************************ PRODUCT ADD TO BUNDLE AND BUTTON CLICK JS START **********************************/

jQuery(document).on("click",".multi-step-bundle-builder-section .product-btn",function(){
    jQuery(this).parent().parent().find('.quantity-selector').css('display','flex');
    jQuery(this).hide();
    var obj = jQuery(this).closest('.product-info');
    var handleVariant = selectVariantGet(obj);
    console.log("handleVariant",handleVariant);
    if(handleVariant!=undefined && handleVariant!=""){
        bundlePackHtml();
    }
});

//Option Change Variant JS start
jQuery(document).on('change', ".multi-step-bundle-builder-section .product-variant-select.dynamic-option", function() {
    var $productInfo = jQuery(this).closest('.product-info');
    console.log("productInfo",$productInfo);
    var selectedVariantId = getVariantId($productInfo);
    console.log("selectedVariantId",selectedVariantId);
    var $quantitySelector = $productInfo.find('.quantity-selector');
    var $addButton = $productInfo.find('.product-btn');
    
    // Find variant in the bundle data array
    var variantData = false;
    if(selectedVariantId!="" && selectedVariantId!=undefined){
        variantData = bundleVariantData.find(function(item) {
            return item.variant_id == selectedVariantId;
        });
    }

    var totalqnt = getTotalVariantQuantity(selectedVariantId);
    if (variantData) {
        // Variant already in bundle → show quantity, hide add button
        $quantitySelector.show();
        $addButton.hide();

        // Set input to stored quantity
        
        $quantitySelector.find('.quantity-value').val(totalqnt);
    } else {
        // Variant not in bundle → show add button, hide quantity
        $quantitySelector.hide();
        $addButton.show();

        // Reset input to minimum
        var min = parseInt($quantitySelector.find('.quantity-value').attr('min')) || 1;
        $quantitySelector.find('.quantity-value').val(min);
    }
});


function accessoriesBoxCard(){
    if(jQuery('.multi-step-bundle-builder-section').find('.add-accessories').length>0){
        var legthProductArr=[];

        jQuery('.multi-step-bundle-builder-section').find('.add-accessories').find('.product-variant-select-wrapper').each(function(){
            if(jQuery(this).length>0){
                var height = jQuery(this).height();
                legthProductArr.push(height);
            }
        });
        var maxValue = Math.max.apply(Math,legthProductArr);
        console.log("maxValue",maxValue);
        jQuery('.multi-step-bundle-builder-section').find('.add-accessories').find('.product-variant-select-wrapper').each(function(){
            if(jQuery(this).length>0){
                jQuery(this).css('height',maxValue);
            }
        });
    }
}
function getTotalVariantQuantity(variantId) {
    if (!variantId || !bundleVariantData || !Array.isArray(bundleVariantData)) return 0;

    var total = 0;
    bundleVariantData.forEach(function(item) {
        if (item.variant_id == variantId) {
            total += parseInt(item.variant_quantity) || 0;
        }
    });

    return total;
}

//PRODUCT COLLECTION QUANTITY PICKER JS START
function setValue(newVal,$input) {
    var min = parseInt($input.attr('min')) || 1;
    var max = parseInt($input.attr('max')) || null;
    if (newVal < min) newVal = min;
    if (max && newVal > max) newVal = max;
    $input.val(newVal).trigger('change');
}
jQuery(document).on("click", ".multi-step-bundle-builder-section .quantity-btn.plus", function () {
    var $btn = jQuery(this);
    var $selector = $btn.parent();
    var $input = $selector.find('.quantity-value');
    var current = parseInt($input.val()) || 0;
    var variantId = parseInt($input.attr('data-variant-id'));
    var obj;
    
    if (!variantId) return; // safety check

    var newVal = current + 1;
    //console.log("new",newVal,current);
   
    if ($btn.hasClass('bundle-picker')) {
        jQuery('.multi-step-bundle-builder-section').find('.quantity-selector .quantity-value[data-variant-id="' + variantId + '"]').each(function () {
            jQuery(this).val(newVal).trigger("change");
            // Show the selector if hidden
            jQuery(this).parent().show();
            jQuery(this).parent().parent().next('.product-btn').hide();
        });

        bundleVariantData.push({
            'variant_price':  $input.attr('data-vprice'),
            'variant_c_price':  $input.attr('data-compare-vprice'),
            'variant_original_price':  $input.attr('data-original-vprice'),
            'variant_original_cprice':  $input.attr('data-original-compare-vprice'),
            'variant_image':  $input.attr('data-vimage'),
            'variant_id': variantId,
            'product_title':  $input.attr('data-ptitle'),
            'variant_handle':  $input.attr('data-vhandle'),
            'variant_quantity': 1
        });
    }else{
        $input.val(newVal).trigger("change");
    }

    // Update bundleVariantData
    var variantIndex = bundleVariantData.findIndex(function (item) {
        return item.variant_id == variantId;
    });

    // Reference current product info for rendering
    obj = $btn.closest('.product-info');
    if (obj && obj.length) {
        var handleVariant = selectVariantGet(obj);
        setTimeout(function () {
            bundlePackHtml();
        }, 100);
    }
});

jQuery(document).on("click",".multi-step-bundle-builder-section .quantity-btn.minus",function (){
    var $selector = jQuery(this).parent();
    var $input = $selector.find('.quantity-value');
    var current = parseInt($input.val()) || 1;

    var variantId = parseInt($input.attr('data-variant-id'));

    if (!variantId) return; // safety check
    console.log("variantId",variantId);
    if (current == 1) {
        // Hide quantity selector and show add button
        $selector.hide();
        $selector.parent().find('.product-btn').show();

        // Remove only one matching variant, not all
        var removeIndex = bundleVariantData.findIndex(function(item) {
            return item.variant_id == variantId;
        });
        if (removeIndex > -1) {
            bundleVariantData.splice(removeIndex, 1);
        }

        // Remove from cart HTML (only one, matching the same variant)
        jQuery('.multi-step-bundle-builder-section')
            .find('.sticky-cart-container .item-card')
            .filter(function(index) {
                return jQuery(this).data('variant-id') == variantId;
            })
            .first()
            .remove();

        jQuery('.multi-step-bundle-builder-section')
            .find('.product-card-wrapper .product-card')
            .filter(function(index) {
                return jQuery(this).data('variant-id') == variantId;
            })
            .first()
            .remove();
        
        if(jQuery(this).hasClass('bundle-picker')){
            if(jQuery('.multi-step-bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').length>0){
                jQuery('.multi-step-bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').parent().hide();
                jQuery('.multi-step-bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').parent().parent().find('.product-btn').show();
                
            }
            
        }
        console.log("bundleVariantData length",bundleVariantData);
        if(bundleVariantData.length==0){
            var comparePrice = theme.Currency.formatMoney(0,theme.settings.moneyFormat);
            var tprice = theme.Currency.formatMoney(0,theme.settings.moneyFormat);
            jQuery('.multi-step-bundle-builder-section').find('.price-section .original-price.compare-price').hide();
            jQuery('.multi-step-bundle-builder-section').find('.price-section .discounted-price.main-price').text(tprice);
        }
    }else{
        var newVal = current - 1;
        if (newVal < 1) newVal = 1;
        $input.val(newVal).trigger('change');

        // Update variant quantity in array
        var removeIndex = bundleVariantData.findIndex(function(item) {
            return item.variant_id == variantId;
        });
        if (removeIndex > -1) {
            bundleVariantData.splice(removeIndex, 1);
        }
        var totalqnt = getTotalVariantQuantity(variantId);
        if(jQuery(this).hasClass('bundle-picker')){
            if(jQuery('.multi-step-bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').length>0){
                jQuery('.multi-step-bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').val(totalqnt);
            }

            if(newVal==1){
                jQuery('.multi-step-bundle-builder-section').find('.product-card-wrapper').find('.product-card[data-variant-id="'+variantId+'"]').find('.minus-icon').hide();
                jQuery('.multi-step-bundle-builder-section').find('.product-card-wrapper').find('.product-card[data-variant-id="'+variantId+'"]').find('.remove-icon').show();
            }
        }
        // Refresh HTML
    }
    setTimeout(function(){
        bundlePackHtml();
    },100);
});
//PRODUCT COLLECTION QUANTITY PICKER JS END

function setColorName(){
    jQuery(".multi-step-bundle-builder-section").find(".grid-product__colors .color-swatch--with-image.active").each(function(){
        var getColor = jQuery(this).attr('data-value');
        if(jQuery(this).parent().parent('div').find('.selected-color').length>0){
            jQuery(this).parent().parent('div').find('.selected-color').text(getColor);
        }
    });
}

function getVariantId(buttonObj){
    if(buttonObj == undefined) return;
    var variantArray = [];
    buttonObj.find('.product-variant-select.dynamic-option').each(function(){
        if(jQuery(this).hasClass('version-variant')){
            var variant_option_val = $(this).find('option:selected').attr('data-option');
            var option_value = $(this).find('option:selected').attr('data-value');
            var variantKey = $(this).attr('data-option-name');
            variantArray.push({ key: variantKey, value: variant_option_val,main_value:option_value });
        }
    });
    var colorSwatch = buttonObj.find('.grid-product__colors .color-swatch-ci.active');
    if(colorSwatch.length > 0){
        var colorVal = colorSwatch.attr('data-option');
        var colorValue = colorSwatch.attr('data-value');
        var colorImage = colorSwatch.attr('data-color-img');
        variantArray.push({ key: 'Color', value: colorVal,main_value:colorValue,'color_image':colorImage });
    }
    // Get dynamic selects
    buttonObj.find('.product-variant-select.dynamic-option').each(function(){
        if(!jQuery(this).hasClass('version-variant')){
            var variant_option_val = $(this).find('option:selected').attr('data-option');
            var option_value = $(this).find('option:selected').attr('data-value');
            var variantKey = $(this).attr('data-option-name');
            variantArray.push({ key: variantKey, value: variant_option_val,main_value:option_value });
        }
    });

    var variant_handle = variantArray.map(function(opt) {
        return opt.value;
    }).join('-');
    var variantId = '';
    if(variant_handle){
       variantId = buttonObj.find('.hidden-variant-select option[data-vhandle="'+variant_handle+'"]').val();
    }
    return variantId;
}

function calculateStrapTotals(bundleData) {
    let strapCount = 0;
    let totalPrice = 0;
    let totalComparePrice = 0;
    let strapCheck = 0;

    // --- Step 1: Count total straps ---
    for (const item of bundleData) {
        if (item) {
            const productTitle = item.product_title?.toLowerCase() || '';
            if (productTitle.includes('strap') && !productTitle.includes('strap bag')) {
                strapCheck = 1;
                strapCount += parseInt(item.variant_quantity) || 0;
            }
        }
    }

    // --- Step 2: Determine paid vs free straps ---
    let paidStraps = 0;
    let freeStraps = 0;
    let strapBoxFree = 0;

    if (strapCount <= 1) {
        paidStraps = strapCount;
        freeStraps = 0;
        strapBoxFree=1;
    } else if (strapCount === 2) {
        paidStraps = 1; // Buy 1 Get 1 Free
        freeStraps = 1;
    } else if (strapCount === 3 || strapCount === 4) {
        paidStraps = 2;
        freeStraps = strapCount - 2;
    } else if (strapCount === 5) {
        paidStraps = 2; // Buy 2 Get 3 Free
        freeStraps = 3;
    } else if (strapCount === 6) {
        paidStraps = 3;
        freeStraps = 3;
        strapBoxFree=6;
    } else if (strapCount === 7) {
        paidStraps = 3;
        freeStraps = 4;
    } else if (strapCount >= 8) {
        paidStraps = strapCount - 4; // 4 free always after 7
        freeStraps = 4;
    }

    if(strapCount == 3){
        strapBoxFree=3;
    }

    if(jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').find('.item-card.blank-card').length>0){
        const $boxes = jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').find('.item-card.blank-card');

        if((strapBoxFree == 1 || strapBoxFree==3 || strapBoxFree == 6) && strapCount>0){
            $boxes.show();
        }else {
            $boxes.hide();
        }
    }
    
    // --- Step 3: Add total for only paid straps ---
    let processedCount = 0;

    for (const item of bundleData) {
        if (item) {
            const productTitle = item.product_title?.toLowerCase() || '';
            if (productTitle.includes('strap') && !productTitle.includes('strap bag')) {
                const quantity = parseInt(item.variant_quantity) || 0;
                const price = parseFloat(item.variant_original_price || 0);
                const comparePrice = parseFloat(item.variant_original_cprice || 0);

                for (let q = 0; q < quantity; q++) {
                    processedCount++;
                    if (processedCount <= paidStraps) {
                        totalPrice += price;
                        totalComparePrice += comparePrice;
                    }
                }
            }
        }
    }

    return {
        strapCount,
        paidStraps,
        freeStraps,
        totalPrice,
        totalComparePrice,
        strapCheck
    };
}


function selectVariantGet(buttonObj){
    //console.log("buttonObj",buttonObj);
    if(buttonObj == undefined) return;
    var variantArray = [];
    var colorSwatch = '';
    if(buttonObj.find('.grid-product__colors .color-swatch-ci.active').length>0){
        colorSwatch = buttonObj.find('.grid-product__colors .color-swatch-ci.active');
    }
    //console.log("buttonObj",buttonObj);
    buttonObj.find('.product-variant-select.dynamic-option').each(function(){
        if(jQuery(this).hasClass('version-variant')){
            var variant_option_val = $(this).find('option:selected').attr('data-option');
            var option_value = $(this).find('option:selected').attr('data-value');
            var variantKey = $(this).attr('data-option-name');
            variantArray.push({ key: variantKey, value: variant_option_val,main_value:option_value });
        }
    });
    
    if(colorSwatch.length > 0){
        var colorVal = colorSwatch.attr('data-option');
        var colorValue = colorSwatch.attr('data-value');
        var colorImage = colorSwatch.attr('data-color-img');
        variantArray.push({ key: 'Color', value: colorVal,main_value:colorValue,'color_image':colorImage });
    }
    // Get dynamic selects
    buttonObj.find('.product-variant-select.dynamic-option').each(function(){
        if(!jQuery(this).hasClass('version-variant')){
            var variant_option_val = $(this).find('option:selected').attr('data-option');
            var option_value = $(this).find('option:selected').attr('data-value');
            var variantKey = $(this).attr('data-option-name');
            variantArray.push({ key: variantKey, value: variant_option_val,main_value:option_value });
        }
    });

    var variant_handle = variantArray.map(function(opt) {
        if(opt.value!="" && opt.value!=undefined){
            return opt.value;
        }
    }).join('-');

    if(variant_handle != "" && variant_handle!=undefined){
        var quantityGet = 1;
        if(jQuery('.multi-step-bundle-builder-section').length>0){
            //console.log("buttonObj",buttonObj);
            var selectedVariant = buttonObj.parent().find('.hidden-variant-select option[data-vhandle="'+variant_handle+'"]');
            quantityGet = 1;
        }
    }else{
        if(jQuery('.multi-step-bundle-builder-section').length>0){
            //console.log("buttonObj",buttonObj);
            var selectedVariant = buttonObj.parent().find('.hidden-variant-select option').first();
            quantityGet = 1;
        }
    }

    if(selectedVariant.length > 0){
        // Usage example:
        let variantId = selectedVariant.val();
        //console.log("variantId",variantId);
        bundleVariantData.push({
            'variant_price': selectedVariant.attr('data-vprice'),
            'variant_c_price': selectedVariant.attr('data-compare-vprice'),
            'variant_original_price': selectedVariant.attr('data-original-vprice'),
            'variant_original_cprice': selectedVariant.attr('data-original-compare-vprice'),
            'variant_image': selectedVariant.attr('data-vimage'),
            'variant_id': variantId,
            'product_title': selectedVariant.attr('data-ptitle'),
            'variant_handle': selectedVariant.attr('data-vhandle'),
            'variant_option': variantArray,
            'variant_quantity': quantityGet
        });
        variant_handle = selectedVariant.attr('data-vhandle');
    }

    console.log("bundleData",bundleVariantData);
    return variant_handle;
}

function findVariantIndex(array, variantId) {
  for (let i = 0; i < array.length; i++) {
    if (array[i].variant_id === variantId) {
      return i; // return index if found
    }
  }
  return -1; // return -1 if not found
}

jQuery(document).on('click',".multi-step-bundle-builder-section .quantity-control .remove-icon",function(){
    var getVariantId = jQuery(this).parent().attr('data-variant-id');
    console.log("getVariantId",getVariantId);
    if(getVariantId!=undefined && getVariantId!=""){
        jQuery(".multi-step-bundle-builder-section").find('.product-card-wrapper').find('.product-card[data-variant-id="'+getVariantId+'"]').remove();
        var variantIndex = bundleVariantData.findIndex(function(item) {
            return item.variant_id == getVariantId;
        });

        if (variantIndex !== -1) {
            bundleVariantData.splice(variantIndex, 1); 
        }
        bundlePackHtml();
    }
});

function bundlePackHtml() {
    var totalQuantity = 0 ;
    var totalComparePrice = 0;
    var totalPrice = 0;
    //console.log("bundleVariantData",bundleVariantData);
    var variantHtmlBundle='';
    
    if (bundleVariantData.length > 0) {
        if (jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').length > 0) {
            if(jQuery('.multi-step-bundle-builder-section').find('.block-item.review-block.active').length>0){
                jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').hide();
            }else{
                jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').show();
            }
            var $wrapper = jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container');
            var $reviewwrapper = jQuery('.multi-step-bundle-builder-section').find('.product-card-wrapper');
            for (var j = 0; j < bundleVariantData.length; j++) {
                var variantId = bundleVariantData[j].variant_id;
                var variantQuantity = bundleVariantData[j].variant_quantity;
                var variantOriginlPrice = bundleVariantData[j].variant_original_price;
                var variantOriginlCPrice = bundleVariantData[j].variant_original_cprice;
                var variantImage = bundleVariantData[j].variant_image;
                var productTitle = bundleVariantData[j].product_title;
                var optionVariant = bundleVariantData[j].variant_option;
                var varaintPrice = bundleVariantData[j].variant_price;
                var varaintCPrice = bundleVariantData[j].variant_c_price;

                // Review Order Html start here
                if(jQuery('.multi-step-bundle-builder-section').length>0){
                    var $existingProduct = $reviewwrapper.find('.product-card').filter(function () {
                        return jQuery(this).data('variant-id') == variantId;
                    });
                    if(jQuery('.multi-step-bundle-builder-section').find('.product-card[data-variant-id="'+variantId+'"]').length>0 && variantQuantity>1){
                        jQuery('.multi-step-bundle-builder-section').find('.product-card[data-variant-id="'+variantId+'"]').find('.quantity-btn .minus-icon').show();
                        jQuery('.multi-step-bundle-builder-section').find('.product-card[data-variant-id="'+variantId+'"]').find('.quantity-btn .remove-icon').hide();
                    }else{
                        jQuery('.multi-step-bundle-builder-section').find('.product-card[data-variant-id="'+variantId+'"]').find('.quantity-btn .minus-icon').hide();
                        jQuery('.multi-step-bundle-builder-section').find('.product-card[data-variant-id="'+variantId+'"]').find('.quantity-btn .remove-icon').show();
                    }
                    var getQuantity = getTotalVariantQuantity(variantId);
                    //console.log("existingProduct",$existingProduct,getQuantity);
                    if ($existingProduct.length) {
                        // Update quantity only
                        $existingProduct.find('.quantity-input').val(getQuantity);
                        if(getQuantity>1){
                            $reviewwrapper.find('.product-card[data-variant-id="'+variantId+'"]').find('.minus-icon').show();
                            $reviewwrapper.find('.product-card[data-variant-id="'+variantId+'"]').find('.remove-icon').hide();
                        }
                    } else {
                        $reviewwrapper.find('.product-card[data-variant-id="'+variantId+'"]').find('.minus-icon').hide();
                        $reviewwrapper.find('.product-card[data-variant-id="'+variantId+'"]').find('.remove-icon').show();
                        var previewOrderHtml = '';
                        // Build new HTML
                        previewOrderHtml += '<div class="product-card" data-variant-id="' + variantId + '"><div class="product-image">';
                        previewOrderHtml += '<img src="' + variantImage + '"></div>';
                        previewOrderHtml += '<div class="product-info"><h3 class="product-title">' + productTitle + '</h3>';
                        previewOrderHtml += '<div class="product-options">';

                        for (var g = 0; g < optionVariant.length; g++) {
                            if (optionVariant[g].key != undefined) {
                                var keyval = optionVariant[g].key.toLowerCase();
                                if (keyval != 'version') {
                                    var value_option = optionVariant[g].main_value;
                                    if (keyval == 'color') {
                                        var colorImg = optionVariant[g].color_image;
                                        previewOrderHtml += '<div class="option-row"><span class="option-label ' + keyval + '">' + optionVariant[g].key + ':</span>';
                                        previewOrderHtml += '<span class="color--swatch"><img src="' + colorImg + '"></span>';
                                        previewOrderHtml += '<span class="option-value">' + value_option + '</span></div>';
                                    } else {
                                        previewOrderHtml += '<div class="option-row"><span class="option-label ' + keyval + '">' + optionVariant[g].key + ':</span>';
                                        previewOrderHtml += '<span class="option-value">' + value_option + '</span></div>';
                                    }
                                }
                            }
                        }
                        previewOrderHtml += '</div>';
                        previewOrderHtml += '<div class="product-pricing-quantity-wrapper"><div class="product-pricing">';
                        if (varaintCPrice != "" && varaintCPrice != undefined) {
                            previewOrderHtml += '<span class="price-original">' + varaintCPrice + '</span>';
                        }
                        previewOrderHtml += '<span class="price-sale">' + varaintPrice + '</span></div>';
                        previewOrderHtml += '<div class="quantity-control"><button class="quantity-btn minus bundle-picker" data-variant-id="'+variantId+'">';
                        console.log("getQuantity",getQuantity);
                        previewOrderHtml += '<svg class="minus-icon" style="display:none;"  xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M0.555542 4.5H9.44421V5.5H0.555542V4.5Z" fill="black"/></svg>';
                    
                        previewOrderHtml += '<svg class="remove-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">';
                        previewOrderHtml += '<path d="M1.75 3.50002H12.25M11.0833 3.50002V11.6667C11.0833 11.9761 10.9604 12.2729 10.7416 12.4916C10.5228 12.7104 10.2261 12.8334 9.91667 12.8334H4.08333C3.77391 12.8334 3.47717 12.7104 3.25838 12.4916C3.03958 12.2729 2.91667 11.9761 2.91667 11.6667V3.50002M4.08333 3.50002L5.25 1.16669H8.75L9.91667 3.50002" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>';
                        previewOrderHtml += '</svg>';
                        previewOrderHtml += '</button><input type="number" class="quantity-input quantity-value" data-variant-id="'+variantId+'" value="' + getQuantity + '"  data-ptitle="'+productTitle+'" data-vimage="'+variantImage+'" data-original-compare-vprice="'+variantOriginlCPrice+'" data-original-vprice="'+variantOriginlPrice+'" data-vprice="'+varaintPrice+'" data-compare-vprice="'+varaintCPrice+'" min="1" pattern="[0-9]*">';
                        previewOrderHtml += '<button class="quantity-btn plus bundle-picker"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">';
                        previewOrderHtml += '<path d="M5.49988 4.49988H9.44421V5.49988H5.49988V9.44421H4.49988V5.49988H0.555542V4.49988H4.49988V0.555542H5.49988V4.49988Z" fill="black"/>';
                        previewOrderHtml += '</svg></button></div></div></div></div>';
                        
                        if(jQuery('.block-item.review-block').length>0 && previewOrderHtml!=""){
                            $reviewwrapper.append(previewOrderHtml);
                        }
                    }
                }
                // Review Order Html end here

                // Sticky Bar Cart Html start here
                if(jQuery('.multi-step-bundle-builder-section').length>0){
                    variantHtmlBundle += '<div class="item-card image-added" data-variant-id="'+variantId+'"><button class="remove-btn">';
                    variantHtmlBundle += '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">';
                    variantHtmlBundle += '<rect x="1" y="1" width="20" height="20" rx="10" fill="#0F0F0F"/><rect x="1" y="1" width="20" height="20" rx="10" stroke="white" stroke-width="2"/>';
                    variantHtmlBundle += '<path d="M13.9998 7.99976L7.99976 13.9998M7.99976 7.99976L13.9998 13.9998" stroke="white" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
                    variantHtmlBundle += '<div class="item-image"><img src="' + variantImage + '" alt="'+productTitle+'"></div>';
                    variantHtmlBundle += '<div class="item-name">'+productTitle+'</div>';
                    variantHtmlBundle += '<div class="item-price"><span class="compare-at-price">'+varaintCPrice+'</span><span class="sale-price">'+varaintPrice+'</span></div></div>';
                }
                // Sticky Bar Cart Html end here
                totalQuantity+=parseInt(variantQuantity);
                totalPrice+=(parseInt(variantOriginlPrice)*variantQuantity);
                if(variantOriginlCPrice!="" && variantOriginlCPrice!=undefined){
                    totalComparePrice+=(parseInt(variantOriginlCPrice)*variantQuantity);
                }
            }
            //console.log("variantHtmlBundle",variantHtmlBundle);
            if($wrapper.length>0 && variantHtmlBundle!=""){
                variantHtmlBundle += blankBoxHtml();
                $wrapper.find('.items-container').html('');
                $wrapper.find('.items-container').html(variantHtmlBundle);
            }
        }
        //console.log("totalQuantity",totalQuantity);
        
    }else{
        if(jQuery('.multi-step-bundle-builder-section').length>0){
            jQuery('.multi-step-bundle-builder-section').find('.item-card.blank-card').show();
        }
        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').hide();
        resetTabsAndProgress();
    }
    const totals = calculateStrapTotals(bundleVariantData);

    //console.log("Strap count (includes free):", totals.strapCount);
    totalPrice = totals.totalPrice;
    totalComparePrice = totals.totalComparePrice;
    //console.log("Strap exists?", totals.strapCheck);
    if(jQuery('.multi-step-bundle-builder-section').find('.price-section').length>0){
        if(jQuery('.multi-step-bundle-builder-section').find('.price-section .main-price').length>0){
            var savingPrice = 0;
            if(totalComparePrice!=0 && parseInt(totalComparePrice)>parseInt(totalPrice)){
                savingPrice = (parseInt(totalComparePrice)-parseInt(totalPrice));
            }
            if(savingPrice>0){
                jQuery('.multi-step-bundle-builder-section').find('.price-section').find('.original-price.compare-price').show();
                jQuery('.multi-step-bundle-builder-section').find('.price-section').find('.savings-badge').show();
                savingPrice = theme.Currency.formatMoney(savingPrice,theme.settings.moneyFormat);
                if(jQuery('.multi-step-bundle-builder-section').find('.price-section .savings-badge').length>0){
                    jQuery('.multi-step-bundle-builder-section').find('.price-section .savings-badge').text(savingPrice);
                }
            }else{
                jQuery('.multi-step-bundle-builder-section').find('.price-section').find('.original-price.compare-price').hide();
                jQuery('.multi-step-bundle-builder-section').find('.price-section').find('.savings-badge').hide();
            }
            console.log("totalComparePrice",totalComparePrice);
            totalComparePrice = theme.Currency.formatMoney(totalComparePrice,theme.settings.moneyFormat);
            totalPrice = theme.Currency.formatMoney(totalPrice,theme.settings.moneyFormat);

            jQuery('.multi-step-bundle-builder-section').find('.price-section .original-price.compare-price').text(totalComparePrice);
            jQuery('.multi-step-bundle-builder-section').find('.price-section .discounted-price.main-price').text(totalPrice);

            if(jQuery('.multi-step-bundle-builder-section').find('.product-cart-footer').length>0){
                jQuery('.multi-step-bundle-builder-section').find('.product-cart-footer').find('.original-price.compare-sub-total').text(totalComparePrice);
                jQuery('.multi-step-bundle-builder-section').find('.product-cart-footer').find('.current-price.sub-total').text(totalPrice);
            }
        }
    }
    bundleMessageCount();
}

//BUNDLE PACK SELECTED TO ADD TO CART JS START 
jQuery(document).on("click",".multi-step-bundle-builder-section .checkout-button",function(){
    bundlePackAddToCart();
});
function bundlePackAddToCart(){
    if(bundleVariantData.length > 0) {
        if(jQuery(".multi-step-bundle-builder-section .checkout-button").length>0){
            jQuery(".multi-step-bundle-builder-section .checkout-button").addClass('btn--loading');
        }
        //console.log("productTitle",bundleVariantData);
        var itemArr=[];
        for (var i = 0; i < bundleVariantData.length; i++) { 
            if (bundleVariantData[i] != undefined) {
                var productTitle = bundleVariantData[i].product_title.toLowerCase();
                var variantQuantity = parseInt(bundleVariantData[i].variant_quantity);
                var variantId = parseInt(bundleVariantData[i].variant_id);
                itemArr.push({
                    id: variantId,
                    quantity: variantQuantity,
                    properties: {'__single_bundle':1}
                });
            }
        }
        if(itemArr.length>0){
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({ items: itemArr }),
                success: function (n) {
                    window.location.href="/checkout";
                },
                error: function (n, c) {
                    if(jQuery(".multi-step-bundle-builder-section .checkout-button").length>0){
                        jQuery(".multi-step-bundle-builder-section .checkout-button").removeClass('btn--loading');
                    }
                    console.log('fail');
                }
            });
        }
    }
}
function sameBoxCard() {
    jQuery('.multi-step-bundle-builder-section .block-item').each(function () {
        var $wrapper = jQuery(this);
        var $section = $wrapper.closest('.multi-step-bundle-builder-section');
        var widthVersion = 0;
        var winWidth = jQuery(window).width();

        if (winWidth >= 1250) {
            widthVersion = 4;
        } else if (winWidth < 1250 && winWidth > 900) {
            widthVersion = 4;
        } else if (winWidth <= 900 && winWidth > 600) {
            widthVersion = 3;
        } else if (winWidth <= 600) {
            widthVersion = 2;
        }
        console.log("widthVersion",widthVersion);

        var $cards = $wrapper.find('.product-info');
        if ($cards.length > 0) {
        // Reset heights before recalculating
        $cards.find('.product-title, .jdgm-preview-badge, .color-variant, .other-options, .product-description').css('height', 'auto');

        for (var i = 0; i < $cards.length; i += widthVersion) {
            var $rowItems = $cards.slice(i, i + widthVersion);

            // Helper function to set equal height for row elements
            function setMaxHeight(selector) {
            var maxHeight = 0;
            $rowItems.each(function () {
                var $el = jQuery(this).find(selector);
                if ($el.length) {
                var h = $el.outerHeight();
                if (h > maxHeight) maxHeight = h;
                }
            });

            // Special case for review badge
            if (selector === '.jdgm-preview-badge') {
                if (maxHeight > 0) {
                $rowItems.each(function () {
                    var $badge = jQuery(this).find('.jdgm-preview-badge');
                    if ($badge.length) {
                    $badge.css('height', maxHeight);
                    } else {
                    // Add invisible placeholder for missing reviews
                    jQuery(this)
                        .find('.product-title')
                        .after('<div class="jdgm-preview-badge" style="visibility:hidden;height:' + maxHeight + 'px;"></div>');
                    }
                });
                }
            } else {
                if (maxHeight > 0) $rowItems.find(selector).css('height', maxHeight);
            }
            }

            // Apply equal heights for all key elements
            setMaxHeight('.product-title');
            setMaxHeight('.jdgm-preview-badge');
            setMaxHeight('.color-variant');
            setMaxHeight('.other-options');
            setMaxHeight('.product-description');
        }
        }
    });

}

jQuery(document).on('click',".multi-step-bundle-builder-section .item-card.image-added .remove-btn",function(){
    var getVariantId = jQuery(this).parent().attr('data-variant-id');
    if(!getVariantId) return;

    // Remove card
    jQuery(this).parent().remove();

    var $input = jQuery('.multi-step-bundle-builder-section')
        .find('.collection-item .quantity-selector .quantity-value[data-variant-id="'+getVariantId+'"]');

    var current = ($input.length > 0) ? parseInt($input.val()) || 1 : 1;

    if($input.length === 0){
        // No quantity picker found → just remove one entry from data
        var removeIndex = bundleVariantData.findIndex(function(item) {
            return item.variant_id == getVariantId;
        });
        if (removeIndex > -1) {
            bundleVariantData.splice(removeIndex, 1);
        }
    } else if (current == 1) {
        // Last piece → remove from array
        var removeIndex = bundleVariantData.findIndex(function(item) {
            return item.variant_id == getVariantId;
        });
        if (removeIndex > -1) {
            bundleVariantData.splice(removeIndex, 1);
        }

        // Reset picker UI
        $input.parent().hide();
        $input.parent().parent().find('.product-btn').show();

        if(bundleVariantData.length == 0){
            var comparePrice = theme.Currency.formatMoney(0,theme.settings.moneyFormat);
            var tprice = theme.Currency.formatMoney(0,theme.settings.moneyFormat);
            jQuery('.multi-step-bundle-builder-section .price-section .original-price.compare-price').hide();
            jQuery('.multi-step-bundle-builder-section .price-section .discounted-price.main-price').text(tprice);
        }
    } else {
        // Reduce quantity instead of removing entry
        var newVal = current - 1;
        

        var variantIndex = bundleVariantData.findIndex(function(item) {
            return item.variant_id == getVariantId;
        });
        if (variantIndex > -1) {
            bundleVariantData.splice(variantIndex, 1);
        }

        $input.val(newVal).trigger('change');
        
        $input.parent().show();
        $input.parent().parent().find('.product-btn').hide();
    }

    // Rebuild cart HTML
    setTimeout(function(){
        bundlePackHtml();
    },100);
});


function blankBoxHtml(){
    if(jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').find('.item-card:not(.blank-card)').length>0){
        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').find('.item-card:not(.blank-card)').remove();
    }
    var htmlBox='';
    htmlBox+='<div class="item-card blank-card"><div class="item-image"><div class="plus-icon">';
    htmlBox+='<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">';
    htmlBox+='<path d="M16.0002 7.61133V25.3891M7.11133 16.5002H24.8891" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>';
    htmlBox+='</svg>FREE</div></div></div>';
    return htmlBox;
}
function bundleMessageCount(){
    let strapCheck = 0;
    let productCount = 0;
    let countProduct = 0;
    let items_subtotal=0;
    if(bundleVariantData.length > 0) {
        for (var i = 0; i < bundleVariantData.length; i++) { 
            if (bundleVariantData[i] != undefined) {
                var productTitle = bundleVariantData[i].product_title.toLowerCase();
                if(productTitle && productTitle.includes('strap') && !productTitle.includes('strap bag')) {
                    strapCheck = 1;
                    productCount++;
                    items_subtotal+=parseInt(bundleVariantData[i].variant_original_price);
                }
            }
            if(jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container').length>0){
                var goalStrap = 3;
                productCount = parseInt(productCount);
                if (productCount > 0) {
                    var remaincount = (goalStrap-productCount);
                    /*if(remaincount>0){
                        if(remaincount>1){
                            discountMoreStrap=remaincount+ ' straps';
                        }else{
                            discountMoreStrap=remaincount+ ' strap';
                        }
                        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.free-strap').show();
                        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.no-free').hide();
                        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.free-strap').find('strong').text(discountMoreStrap);
                        jQuery('.multi-step-bundle-builder-section').find('.product-cart-wrapper').find('.price-row.free-shipping-row').hide();
                    }else{*/
                        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.free-strap').hide();
                        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.no-free').show();
                        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.no-free').find('span').text('('+bundleVariantData.length+')');
                        jQuery('.multi-step-bundle-builder-section').find('.product-cart-wrapper').find('.price-row.free-shipping-row').show();
                    //}
                }
            }
        }
    }else if(jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.free-strap').length>0){
        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.free-strap').show();
        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.no-free').hide();
        jQuery('.multi-step-bundle-builder-section').find('.sticky-cart-container .cart-title.free-strap').find('strong').text('3 straps');
    }
}

var timerInterval; // define globally so it can be checked later

function reserveTimer() {
    var $reviewBlock = jQuery('.multi-step-bundle-builder-section').find('.block-item.review-block');
    
    if ($reviewBlock.length > 0) {
        // if timer is already running, don’t start again
        if ($reviewBlock.data('timer-running')) {
            return;
        }

        var getMinute = $reviewBlock.attr('data-time');
        if (getMinute && getMinute != "") {
            var totalSeconds = parseInt(getMinute) * 60;

            function updateTimer() {
                var hours = Math.floor(totalSeconds / 3600);
                var minutes = Math.floor((totalSeconds % 3600) / 60);
                var seconds = totalSeconds % 60;

                var hDisplay = hours < 10 ? "0" + hours : hours;
                var mDisplay = minutes < 10 ? "0" + minutes : minutes;
                var sDisplay = seconds < 10 ? "0" + seconds : seconds;

                $reviewBlock.find('.cart-reserve-timer').text(hDisplay + ":" + mDisplay + ":" + sDisplay);
            }

            // start countdown timer
            timerInterval = setInterval(function() {
                if (totalSeconds <= 0) {
                    clearInterval(timerInterval);
                    $reviewBlock.find('.cart-reserve-timer').text("00:00:00");
                    $reviewBlock.data('timer-running', false);
                } else {
                    totalSeconds--;
                    updateTimer();
                }
            }, 1000);

            // mark timer as running
            $reviewBlock.data('timer-running', true);

            updateTimer();
        }
    }
}

//BUNDLE PACK SELECTED TO ADD TO CART JS START 
jQuery(document).on("click",".multi-step-bundle-builder-section .checkout-button",function(){
    bundlePackAddToCart();
});
function bundlePackAddToCart(){
    if(bundleVariantData.length > 0) {
        if(jQuery(".multi-step-bundle-builder-section .block-banner-content-wrapper").length>0){
            jQuery(".multi-step-bundle-builder-section .block-banner-content-wrapper").find(".checkout-button").addClass('btn--loading');
        }
        //console.log("productTitle",bundleVariantData);
        var itemArr=[];
        for (var i = 0; i < bundleVariantData.length; i++) { 
            if (bundleVariantData[i] != undefined) {
                var productTitle = bundleVariantData[i].product_title.toLowerCase();
                var variantQuantity = parseInt(bundleVariantData[i].variant_quantity);
                var variantId = parseInt(bundleVariantData[i].variant_id);
                itemArr.push({
                    id: variantId,
                    quantity: variantQuantity,
                    properties: {'__single_bundle':1}
                });
            }
        }
        if(itemArr.length>0){
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({ items: itemArr }),
                success: function (n) {
                    window.location.href="/checkout";
                },
                error: function (n, c) {
                    if(jQuery(".multi-step-bundle-builder-section .block-banner-content-wrapper").length>0){
                        jQuery(".multi-step-bundle-builder-section .block-banner-content-wrapper").find(".checkout-button").removeClass('btn--loading');
                    }
                    console.log('fail');
                }
            });
        }
    }
}